import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles, requireProfile = true }) {
    const { user, profile, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center" style={{ color: "var(--text-tertiary)" }}>Chargement…</div>;
    }
    if (!user) {
        return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
    }
    if (roles && !roles.includes(user.role)) {
        return <Navigate to="/" replace />;
    }
    // Everyone (except admin pages which opt out) must pick a profile first.
    // Admin & staff bypass the profile picker — their dashboards use user_id directly.
    const isStaff = ["super_admin", "shop_admin", "teacher"].includes(user.role);
    if (requireProfile && !profile && !isStaff && location.pathname !== "/profils") {
        return <Navigate to={`/profils?redirect=${encodeURIComponent(location.pathname)}`} replace />;
    }
    return children;
}
